import React, { createContext, useContext, useState, ReactNode } from 'react';
import moment, { Moment } from 'moment';


interface MapContextType {
    errorDateMessage: string,
    setErrorDateMessage: (message:string) => void
    momentToday: Moment,
    minDate: Moment,
    maxDate: Moment,
    dateDeb: Date,
    dateFin: Date,
    selectedBoatCodes: string[],
    uniqueBoats: string[],
    setDateDeb: (date:Date) => void;
    setDateFin: (date:Date) => void;
    setSelectedBoatCodes: (code:string[]) => void;
    setUniqueBoats: (boats:string[]) => void;
}

interface MapProviderProps {
    children: ReactNode;
}

const MapContext = createContext<MapContextType | null>(null);



export const MapProvider: React.FC<MapProviderProps> = ({ children }) => {

    const now = new Date();
    const dateToday = new Date(now);
    const dateYesterday = new Date(now);
    dateYesterday.setDate(now.getDate() - 1);

    const season = dateToday.getFullYear();
    const momentToday = moment(dateToday); 
    const minDate = moment(season.toString() + "-01-01");
    const maxDate = moment((season + 1).toString() + "-01-01");


    const [errorDateMessage, setErrorDateMessage] = useState<string>("");
    const [dateDeb, setDateDeb] = useState<Date>(dateYesterday);
    const [dateFin, setDateFin] = useState<Date>(now);
    const [selectedBoatCodes, setSelectedBoatCodes] = useState<string[]>([]);
    const [uniqueBoats, setUniqueBoats] = useState<string[]>([]);

    
    
    const contextValues = { 
        errorDateMessage,
        setErrorDateMessage,
        momentToday,
        minDate,
        maxDate,
        dateDeb,
        dateFin,
        selectedBoatCodes,
        uniqueBoats,
        setDateDeb,
        setDateFin,
        setSelectedBoatCodes,
        setUniqueBoats,
    };


    return (
      <MapContext.Provider value={contextValues}>
        {children}
      </MapContext.Provider>
    );
};


export const useMapContext = (): MapContextType => {
    const context = useContext(MapContext);
    if (!context) {
      throw new Error('useMapContext doit être utilisé dans un MapProvider');
    }
    return context;
};
